import { Tabs } from '@mantine/core';

import { AddonsList } from './addons/AddonsList';
import { RefuseReasonsList } from './refuseReasons/RefuseReasonsList';
import { ServiceTypesList } from './serviceTypes/ServiceTypesList';
import { TaskTypesList } from './taskTypes/TaskTypesList';

export const DictionariesList = () => {
  return (
    <Tabs defaultValue="refuse-reasons" variant="default" keepMounted={false}>
      <Tabs.List>
        <Tabs.Tab value="refuse-reasons">Refuse reasons</Tabs.Tab>
        <Tabs.Tab value="task-types">Task types</Tabs.Tab>
        <Tabs.Tab value="service-types">Service types</Tabs.Tab>
        <Tabs.Tab value="addons">Add-ons</Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="refuse-reasons" pt={0}>
        <RefuseReasonsList />
      </Tabs.Panel>

      <Tabs.Panel value="task-types" pt={0}>
        <TaskTypesList />
      </Tabs.Panel>

      <Tabs.Panel value="service-types" pt={0}>
        <ServiceTypesList />
      </Tabs.Panel>

      <Tabs.Panel value="addons" pt={0}>
        <AddonsList />
      </Tabs.Panel>
    </Tabs>
  );
};
